import React, { useState } from "react";
import axiosInstance from "../../Axios/axiosInstance";
import {
  TextField,
  Button,
  Grid,
  Typography,
  Divider,
  Box,
  Snackbar,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";

const AddLead = () => {
  const [leadData, setLeadData] = useState({
    leadName: "",
    contactNo: "",
    leadEmail: "",
    leadLocation: "",
    leadSource: "",
    leadComments: "",
    status: "active",
  });

  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [submitMessage, setSubmitMessage] = useState("");

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setLeadData({ ...leadData, [name]: value });
  };

  const validate = () => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const numberRegex = /^[0-9]+$/;

    if (
      leadData.leadEmail.trim() !== "" &&
      !emailRegex.test(leadData.leadEmail)
    ) {
      return false;
    }

    if (
      leadData.contactNo.trim() !== "" &&
      !numberRegex.test(leadData.contactNo)
    ) {
      return false;
    }

    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log(leadData);
    if (validate() && leadData.leadName.trim() !== "") {
      try {
        const response = await axiosInstance.post("/api/addLead", leadData);

        if (response.status === 201) {
          setOpenSnackbar(true);
          setSubmitMessage("Lead data saved successfully!");

          setLeadData({
            leadName: "",
            contactNo: "",
            leadEmail: "",
            leadLocation: "",
            leadSource: "",
            leadComments: "",
            status: "active",
          });
        } else {
          console.error(
            "Failed to save lead data - Server responded with status:",
            response.status
          );
          console.error("Response data:", response.data);
          setOpenSnackbar(true);
          setSubmitMessage("Failed to save lead data. Please try again.");
        }
      } catch (error) {
        console.error("Error occurred:", error);
        setOpenSnackbar(true);
        setSubmitMessage(
          "An unexpected error occurred. Please try again later."
        );
      }
    }
  };

  const handleCloseSnackbar = () => {
    setOpenSnackbar(false);
  };

  return (
    <>
      <form onSubmit={handleSubmit}>
        <Grid
          container
          spacing={3}
        >
          {/* Lead Registration Heading */}
          <Grid
            container
            item
            xs={12}
          >
            <Grid
              item
              xs={8}
            >
              <Typography
                variant="h5"
                align="left"
              >
                Add Leads
              </Typography>
            </Grid>
            {/* <Grid
              item
              xs={4}
              className="text-end"
            >
              <EditIcon />
            </Grid> */}
          </Grid>

          {/* Divider line */}
          <Grid
            item
            xs={12}
          >
            <Box>
              <Divider
                variant="fullWidth"
                style={{ backgroundColor: "black" }}
              />
            </Box>
          </Grid>

          {/* Lead Details */}
          <Grid
            item
            xs={12}
            className=""
          >
            <Typography
              variant="h6"
              align="left"
            >
              Lead Details
            </Typography>
          </Grid>

          {/* Input Fields */}
          <Grid
            item
            xs={12}
            className="text-center"
            lg={6}
            md={6}
            sm={12}
          >
            <Grid
              container
              alignItems="center"
            >
              <Grid
                item
                style={{ textAlign: "left" }}
                xs={3}
              >
                <Typography variant="subtitle1">Lead Name</Typography>
              </Grid>
              <Grid item>
                <TextField
                  fullWidth
                  name="leadName"
                  value={leadData.leadName}
                  onChange={handleInputChange}
                  size="small"
                  required
                  className="ms-3"
                />
              </Grid>
            </Grid>
          </Grid>

          <Grid
            item
            xs={12}
            className="text-center"
            lg={6}
            md={6}
            sm={12}
          >
            <Grid
              container
              alignItems="center"
            >
              <Grid
                item
                style={{ textAlign: "left" }}
                xs={3}
              >
                <Typography variant="subtitle1">Contact Number</Typography>
              </Grid>
              <Grid item>
                <TextField
                  fullWidth
                  name="contactNo"
                  value={leadData.contactNo}
                  onChange={handleInputChange}
                  size="small"
                  required
                  className="ms-3"
                />
              </Grid>
            </Grid>
          </Grid>

          <Grid
            item
            xs={12}
            lg={6}
            md={6}
            sm={12}
          >
            <Grid
              container
              alignItems="center"
            >
              <Grid
                item
                style={{ textAlign: "left" }}
                xs={3}
              >
                <Typography variant="subtitle1">Lead Email</Typography>
              </Grid>
              <Grid item>
                <TextField
                  fullWidth
                  size="small"
                  name="leadEmail"
                  value={leadData.leadEmail}
                  onChange={handleInputChange}
                  className="ms-3"
                  required
                />
              </Grid>
            </Grid>
          </Grid>

          <Grid
            item
            xs={12}
            lg={6}
            md={6}
            sm={12}
          >
            <Grid
              container
              alignItems="center"
            >
              <Grid
                item
                style={{ textAlign: "left" }}
                xs={3}
              >
                <Typography variant="subtitle1">Lead Location</Typography>
              </Grid>
              <Grid item>
                <TextField
                  fullWidth
                  name="leadLocation"
                  value={leadData.leadLocation}
                  onChange={handleInputChange}
                  size="small"
                  className="ms-3"
                />
              </Grid>
            </Grid>
          </Grid>

          <Grid
            item
            xs={12}
            className="text-center"
            lg={6}
            md={6}
            sm={12}
          >
            <Grid
              container
              alignItems="center"
            >
              <Grid
                item
                style={{ textAlign: "left" }}
                xs={3}
              >
                <Typography variant="subtitle1">Lead Source</Typography>
              </Grid>
              <Grid item>
                <TextField
                  fullWidth
                  name="leadSource"
                  value={leadData.leadSource}
                  onChange={handleInputChange}
                  size="small"
                  className="ms-3"
                />
              </Grid>
            </Grid>
          </Grid>

          <Grid
            item
            xs={12}
            lg={6}
            md={6}
            sm={12}
          >
            <Grid
              container
              alignItems="center"
            >
              <Grid
                item
                style={{ textAlign: "left" }}
                xs={3}
              >
                <Typography variant="subtitle1">Lead Comments</Typography>
              </Grid>
              <Grid item>
                <TextField
                  fullWidth
                  name="leadComments"
                  value={leadData.leadComments}
                  onChange={handleInputChange}
                  size="small"
                  className="ms-3"
                  rows={2}
                  // multiline
                />
              </Grid>
            </Grid>
          </Grid>

          {/* Status */}

          {/* Submit Button */}
          <Grid
            item
            xs={12}
            className=" mt-5"
          >
            <Button
              variant="contained"
              color="primary"
              type="submit"
            >
              Save
            </Button>
          </Grid>
        </Grid>
      </form>

      {/* Success Snackbar */}
      <Snackbar
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        open={openSnackbar}
        autoHideDuration={3000}
        onClose={handleCloseSnackbar}
        message={submitMessage}
      />
    </>
  );
};

export default AddLead;
